import React from 'react';

const NextMakerMethodology = () => {

   return (
      <section className="relative p-5 md:px-32 py-12 md:py-16 lg:py-24 overflow-hidden">
         {/* Background avec image */}
         <div className="absolute inset-0 z-0">
            <div
               className="w-full h-full bg-cover bg-center bg-no-repeat"
               style={{ backgroundImage: "url('/home-8/grow/bg.png')" }}
            ></div>
            {/* <div className="absolute inset-0 bg-blue-900/80"></div> */}
         </div>

         <div className="container mx-auto px-4 relative z-10">
            <div className="flex flex-col lg:flex-row justify-between items-center gap-10">
               {/* Texte de contenu */}
               <div className="lg:w-2/5">
                  <h2 className="text-3xl md:text-title font-bold text-white leading-tight">
                     Méthodologie NextMaker
                  </h2>
                  <p className="text-white/90 mt-4 text-subtitle">
                     Cours interactifs → Dojos pratiques → Lab/résidence → Certification.
                  </p>
                  <div className="mt-6">
                     <a
                        href="/next-maker-method"
                        className="inline-block px-6 text-button py-6 bg-red-4 text-white hover:text-red-4 font-medium rounded-full transition-colors
                duration-300 border-2 border-red-4 hover:bg-white"
                     >
                        En savoir plus sur la Méthodologie NextMaker
                     </a>
                  </div>
               </div>

               {/* Cartes de statistiques */}
               <div className="w-full lg:w-1/2">
                  <div className="grid grid-cols-1 md:grid-cols-2 items-center md:h-[600px] gap-6 md:gap-8">

                     {/* Colonne gauche */}
                     <div className="flex flex-col justify-between h-full gap-6 md:gap-8">
                        {/* Carte 1 en haut */}
                        <div className="flex items-center justify-center bg-white rounded-2xl h-[220px] sm:h-[250px] md:h-[280px] w-full">
                           <div className="text-center">
                              <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-dark-1">9/10</div>
                              <div className="mt-3 sm:mt-4 text-base sm:text-lg text-gray-600">
                                 Overall courses satisfaction score
                              </div>
                           </div>
                        </div>

                        {/* Carte 2 en bas */}
                        <div className="flex items-center justify-center bg-white rounded-2xl h-[220px] sm:h-[250px] md:h-[280px] w-full">
                           <div className="text-center">
                              <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-dark-1">96%</div>
                              <div className="mt-3 sm:mt-4 text-base sm:text-lg text-gray-600">
                                 Completion Rate On All Courses
                              </div>
                           </div>
                        </div>
                     </div>

                     {/* Colonne droite */}
                     <div className="flex items-center justify-center h-full">
                        <div className="flex items-center justify-center bg-white rounded-2xl h-[220px] sm:h-[250px] md:h-[280px] w-full">
                           <div className="text-center">
                              <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-dark-1">10K+</div>
                              <div className="mt-3 sm:mt-4 text-base sm:text-lg text-gray-600">
                                 Happy Students Worldwide
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>


            </div>
         </div>
      </section>
   );
};

export default NextMakerMethodology;